/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const listItemTokens = {
  ContainerBackgroundColorBannerDefault: '#fff2d6',
  ContainerBorderColorBannerDefault: '#ffedc7',
  ContainerBorderWidthBannerDefault: '1px',
  ContainerBorderStyleBannerDefault: 'solid',
  ContainerFontColorBannerDefault: '#a36f00',
  ContainerSpacingOuterBottomLargeDefault: '16px',
  ContainerSpacingOuterBottomMediumDefault: '14px',
  ContainerSpacingOuterBottomSmallDefault: '12px',
  ContainerSpacingInnerBottomLargeDefault: '16px',
  ContainerSpacingInnerBottomMediumDefault: '14px',
  ContainerSpacingInnerBottomSmallDefault: '12px',
  ContainerSpacingInnerTopBaseDefault: '0',
  ContainerSpacingInnerHorizontalBaseDefault: '0',
  ContentSpacingLeftBaseDefault: '12px',
  DividerColorBaseDefault: '#c4c4c4',
  DividerHeightBaseDefault: '1px',
  DividerWidthBaseDefault: '100%',
  ConnectorColorBaseDefault: '#dedfdf',
} as const;
